<template>
  <div v-if="hasAnyAlert" class="flex flex-col gap-2 mb-4 noprint">
    <SuspendedOrgAlert v-if="base.suspended" :data="base.suspended" />
    <GoogleAccountsIssuesAlert v-if="base.googleAccountsIssues" :data="base.googleAccountsIssues" />
    <DisconnectedGoogleAlert v-if="base.disconnectedGoogleAccounts" :data="base.disconnectedGoogleAccounts" />
    <SubscriptionAlert v-if="base.subscription" :data="base.subscription" />
    <LimitReachedAlert v-if="base.limitReached" :data="base.limitReached" />
    <DisconnectedFacebookAlert v-if="base.disconnectedFacebookAccounts" :data="base.disconnectedFacebookAccounts" />
    <CustomAlertItem
      v-for="alert in custom"
      :key="alert.id"
      :alert="alert" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useGlobalStore } from '@/stores/global'
import { getRouter } from '@/router/instance'
import matchesPathPrefixes from '@/common/matchesPathPrefixes'
import SuspendedOrgAlert from './SuspendedOrgAlert.vue'
import GoogleAccountsIssuesAlert from './GoogleAccountsIssuesAlert.vue'
import DisconnectedGoogleAlert from './DisconnectedGoogleAlert.vue'
import SubscriptionAlert from './SubscriptionAlert.vue'
import LimitReachedAlert from './LimitReachedAlert.vue'
import DisconnectedFacebookAlert from './DisconnectedFacebookAlert.vue'
import CustomAlertItem from './CustomAlertItem.vue'

// Alerts are delivered up-front via the Global styxie (see GlobalSerializer),
// so we read them straight from the store instead of a per-page API request.
const globalStore = useGlobalStore()
const router = getRouter()

const currentPath = computed(() => (
  router ? router.currentRoute.value.path : window.location.pathname
))

const base = computed(() => globalStore.orgAlerts.base || {})
const custom = computed(() => (
  (globalStore.orgAlerts.custom || []).filter((alert) => matchesPathPrefixes(currentPath.value, alert.pathPrefixes))
))

const hasAnyAlert = computed(() => (
  Object.values(base.value).some(Boolean) || custom.value.length > 0
))
</script>
